(() => {
  function init(root) {
    if (root.dataset.mvReady) return;
    root.dataset.mvReady = 'true';
    const cards = [...root.querySelectorAll('[data-mv-card]')];
    const tools = root.querySelector('[data-mv-tools]');
    if (!tools || !cards.length) return;
    const input = root.querySelector('[data-mv-search]');
    const filters = root.querySelector('[data-mv-filters]');
    const count = root.querySelector('[data-mv-count]');
    const empty = root.querySelector('[data-mv-empty]');
    let category = '';
    const buttons = [];
    ['', ...new Set(cards.map(c => c.dataset.category).filter(Boolean))].forEach(value => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mv-solutions__filter';
      button.textContent = value || root.dataset.allLabel;
      button.dataset.category = value;
      button.setAttribute('aria-pressed', value === '' ? 'true' : 'false');
      button.addEventListener('click', () => { category = value; update(); });
      filters.append(button);
      buttons.push(button);
    });
    function update() {
      const query = input.value.trim().toLocaleLowerCase();
      let visible = 0;
      cards.forEach(card => {
        const match = (!category || card.dataset.category === category) && (!query || card.dataset.search.toLocaleLowerCase().includes(query));
        card.hidden = !match;
        if (match) visible++;
      });
      buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.category === category)));
      count.textContent = `${visible} / ${cards.length} ${root.dataset.countLabel}`;
      empty.hidden = visible !== 0;
    }
    input.addEventListener('input', update);
    root.querySelector('[data-mv-reset]').addEventListener('click', () => { input.value = ''; category = ''; update(); input.focus(); });
    tools.hidden = false;
    count.hidden = false;
    update();
  }
  function boot(scope) {
    if (scope.matches && scope.matches('[data-mv-directory]')) init(scope);
    scope.querySelectorAll('[data-mv-directory]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
